var map = {
	"./1.jpg": 994,
	"./10.jpg": 995,
	"./11.jpg": 996,
	"./12.jpg": 997,
	"./13.jpg": 998,
	"./14.jpg": 999,
	"./15.jpg": 1000,
	"./16.jpg": 1001,
	"./17.jpg": 1002,
	"./18.jpg": 1003,
	"./19.jpg": 1004,
	"./2.jpg": 1005,
	"./20.jpg": 1006,
	"./21.jpg": 1007,
	"./22.jpg": 1008,
	"./23.jpg": 1009,
	"./24.jpg": 1010,
	"./25.jpg": 1011,
	"./3.jpg": 1012,
	"./4.jpg": 1013,
	"./5.jpg": 1014,
	"./6.jpg": 1015,
	"./7.jpg": 1016,
	"./8.jpg": 1017,
	"./9.jpg": 1018
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 993;